import React from 'react';

const ViewClientProject=React.lazy(()=>import('./ViewClientProject'));
const ProjectInfoForm=React.lazy(()=>import('./ClientProjectInfo'));
const DocumentUploadedByEmp=React.lazy(()=>import('./DocumentUploadedByEmp'));
const UploadClientDocument=React.lazy(()=>import('./UploadClientDocument'));
const ViewProjectForm=React.lazy(()=>import('./ViewProjectForm'));
export {
    ViewClientProject,
    ProjectInfoForm,
    DocumentUploadedByEmp,
    UploadClientDocument,
    ViewProjectForm
}